import { useEffect } from 'react';
/**
 * useEffectのdicMount時の1回起動のみ
 * @param callback
 */
export const useDidMount = (callback) => {
    useEffect(() => {
        callback();
        return undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
